<div style="height: 100%; width: 100%;">
  <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="currentTemplate"> </ng-container>
</div>
